import { render, staticRenderFns } from "./PremiumDashboard.vue?vue&type=template&id=b61ce7dc&scoped=true"
import script from "./PremiumDashboard.vue?vue&type=script&lang=js"
export * from "./PremiumDashboard.vue?vue&type=script&lang=js"
import style0 from "./PremiumDashboard.vue?vue&type=style&index=0&id=b61ce7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ce7dc",
  null
  
)

export default component.exports